module.exports = __webpack_public_path__ + "static/media/icon-small-trash.ddaa8257.svg";